export default __webpack_public_path__ + "static/media/combined.a7a4f17e.png";